import { useNavigate } from "@tanstack/react-router";
import { Trash2 } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { trpc } from "../../lib/trpc";
import { Button } from "../ui";
import { DeleteClubModal } from "./DeleteClubModal";

type Props = {
  clubId: string;
  clubName: string;
};

export function DangerSection({ clubId, clubName }: Props) {
  const utils = trpc.useUtils();
  const navigate = useNavigate();
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const deleteMutation = trpc.club.delete.useMutation({
    onSuccess: () => {
      toast.success("Club deleted");
      void utils.club.getMyClubs.invalidate();
      void utils.club.list.invalidate();
      void navigate({ to: "/app/clubs" });
    },
    onError: () => toast.error("Failed to delete club"),
  });

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-semibold text-white">Delete Club</p>
          <p className="text-xs text-surface-400 mt-0.5">
            Permanently delete this club and all its data. This cannot be undone.
          </p>
        </div>
        <Button
          variant="outline"
          size="sm"
          className="!border-error-500/40 !text-error-400 hover:!bg-error-500/10"
          leftIcon={<Trash2 className="size-3.5" />}
          onClick={() => setShowDeleteModal(true)}
        >
          Delete Club
        </Button>
      </div>

      <DeleteClubModal
        open={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        clubName={clubName}
        isPending={deleteMutation.isPending}
        onConfirm={() => deleteMutation.mutate({ clubId })}
      />
    </div>
  );
}
